import React from 'react'
import styled, { keyframes } from 'styled-components'

export const FlagComponent = () => {
  return (
    <FlagWrapper>
      <FlagInner>
        <Flag>
          <Blue></Blue>
          <Yellow></Yellow>
        </Flag>
        <FlagWave></FlagWave>
      </FlagInner>
    </FlagWrapper>
  )
}

const flagwave = keyframes`
   0% {
      
        left: -60px;
      
    }

    100% {
      
        left: 60px;
      
    }
`
const FlagWave = styled.div`
  width: 40px;
  height: 20px;
  position: absolute;
  left: 0;
  top: 0;
  background-image: -webkit-gradient(
      linear,
      0% 30%,
      50% top,
      color-stop(0%, rgba(255, 255, 255, 0)),
      color-stop(40%, rgba(255, 255, 255, 0)),
      color-stop(90%, rgba(255, 255, 255, 0.3)),
      color-stop(100%, rgba(255, 255, 255, 0))
    ),
    -webkit-gradient(linear, 50% 30%, 100% top, color-stop(0%, rgba(224, 225, 225, 0)), color-stop(25%, rgba(225, 225, 225, 0.3)), color-stop(50%, rgba(224, 225, 225, 0)), color-stop(80%, rgba(224, 225, 225, 0.3)), color-stop(100%, rgba(224, 225, 225, 0)));

  background-size: 200%;
  background-position: right;
  animation: ${flagwave} 2s linear infinite;
`

const FlagWrapper = styled.div`
  position: absolute;
  right: 26px;
`

const FlagInner = styled.div`
  width: 40px;
  height: 20px;
  position: relative;
  overflow: hidden;
`
const Flag = styled.div`
  width: 40px;
  height: 20px;
`
const Blue = styled.div`
  width: 40px;
  height: 10px;
  background: rgb(0, 87, 184);
`
const Yellow = styled.div`
  width: 60px;
  height: 15px;
  background: rgb(255, 216, 0);
`
